import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { getHasta, getHastaMuayeneleri } from '../services/api';

const trTarih = (s) => s ? new Date(s).toLocaleDateString('tr-TR') : '—';

export default function MuayeneGecmis() {
  const { kayitNo } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const gelisYeri = location.state?.from === 'randevular'
    ? { yol: '/randevular', etiket: '← Randevu Listesine Geri Dön' }
    : { yol: '/muayeneler', etiket: '← Muayene Listesine Geri Dön' };
  const [hasta, setHasta] = useState(null);
  const [liste, setListe] = useState([]);
  const [yukleniyor, setYukleniyor] = useState(true);

  useEffect(() => {
    getHasta(kayitNo).then(r => setHasta(r.data)).catch(() => {});
    getHastaMuayeneleri(kayitNo)
      .then(r => setListe(r.data))
      .catch(() => setListe([]))
      .finally(() => setYukleniyor(false));
  }, [kayitNo]);

  return (
    <div>
      <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <span onClick={() => navigate(gelisYeri.yol)}
                style={{ color: 'var(--mor)', cursor: 'pointer', fontSize: 13.5, fontWeight: 600 }}>
            {gelisYeri.etiket}
          </span>
          <button className="btn-ikincil" onClick={() => navigate(`/hasta/${kayitNo}`, { state: { from: 'muayene-gecmis', fromLabel: 'Muayene Geçmişine Geri Dön' } })}>
            Hasta Kartı
          </button>
        </div>
        {/* <button className="btn" onClick={() => navigate(`/hasta/${kayitNo}/muayene-yeni`)}>＋ Yeni Muayene</button> */}
      </div>

      <h1 className="sayfa-baslik">🩺 Muayene Geçmişi</h1>
      <p className="sayfa-alt">{hasta ? hasta.hesapAdi : `Hasta No: ${kayitNo}`}</p>

      <div className="kart" style={{ overflow: 'hidden' }}>
        {yukleniyor ? (
          <div className="bos-durum">Yükleniyor…</div>
        ) : liste.length === 0 ? (
          <div className="bos-durum">Bu hastaya ait muayene kaydı bulunamadı.</div>
        ) : (
          <table className="tablo">
            <thead>
              <tr>
                <th style={{ width: 110 }}>Tarih</th>
                <th style={{ width: 60 }}>Saat</th>
                <th style={{ width: 150 }}>Doktor</th>
                <th>Özet</th>
              </tr>
            </thead>
            <tbody>
              {liste.map(m => (
                <tr key={m.id} onClick={() => navigate(`/muayene/${m.id}`)}>
                  <td style={{ fontWeight: 600 }}>{trTarih(m.tar)}</td>
                  <td>{m.saat}</td>
                  <td style={{ color: 'var(--metin-soluk)' }}>{m.doktor || '—'}</td>
                  <td style={{ color: 'var(--metin-soluk)', fontSize: 13 }}>{m.ozet || '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
      {!yukleniyor && liste.length > 0 && (
        <div style={{ marginTop: 10, fontSize: 13, color: 'var(--metin-soluk)' }}>
          {liste.length} muayene kaydı.
        </div>
      )}
    </div>
  );
}
